import { useMemo } from "react";
import { Platform } from "react-native";

export function useIsMobileOnWeb() {
  return useMemo(() => {
    if (Platform.OS !== "web") {
      return false;
    }

    const userAgent = navigator.userAgent.toLowerCase();

    const isAndroid = Boolean(userAgent.match(/Android/i));
    const isIos = Boolean(userAgent.match(/iPhone|iPad|iPod/i));
    const isIpad = Boolean(userAgent.match(/mac/i) && "ontouchend" in document);
    const isOpera = Boolean(userAgent.match(/Opera Mini/i));
    const isWindows = Boolean(userAgent.match(/IEMobile/i));

    return isAndroid || isIos || isIpad || isOpera || isWindows;
  }, []);
}
